import React from 'react';
import { AccountTabParamList } from '../../../../../utils/appNavigationNames';
import { RouteProp } from '@react-navigation/native';
import UserAccountInformationScreen from '../../../../shared/Account/UserAccountInformationScreen';

export type AccountInformationScreenOwnProps = {};

export type AccountScreenInformationProps = AccountInformationScreenOwnProps & {
    route: RouteProp<AccountTabParamList, 'information'>;
};

const AccountInformationScreen: React.FC<AccountScreenInformationProps> = (props) => {
    return <UserAccountInformationScreen defaultToEdit={!!props.route.params?.defaultToEdit} />;
};

export default React.memo(AccountInformationScreen);
